var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('table-ag',{ref:"tableEmployeesCl7",attrs:{"row-data":_vm.employees,"column-defs":_vm.columns,"components":_vm.components,"component-menu":_vm.componentMenu,"actions":true,"pagination":false,"auto-height":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c885d9f0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/climan/Surveys.vue
// module id = 1361
// module chunks = 2